import styled from "styled-components";

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  list-style: none;
`;

export { Ul };
